import { HEARING_AID_TYPES, WARRANTY_SUBTYPE } from "constants/products";
import {
  ACCESSORY_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE,
  SERVICE_PRODUCT_TYPE,
} from "constants/sales";
import { MasterProduct } from "services/types/master-products.type";

export const getSpecificationPreviewText = (option: MasterProduct) => {
  const { type, subtype } = option;

  const result: string[] = [];
  if (option.cpt_code) {
    result.push(`CPT: ${option.cpt_code.code}`);
  }
  if (option.specification) {
    const spec = option.specification as any;
    if (spec.type) {
      if (type === HEARING_AID_PRODUCT_TYPE) {
        result.push(`Type: ${HEARING_AID_TYPES.getFromCode(spec.type)}`);
      } else if (type === ACCESSORY_PRODUCT_TYPE) {
        result.push(`Type: ${spec.type}`);
      }
    }
    if (spec.size) result.push(`Size: ${spec.size}`);
    if (type === SERVICE_PRODUCT_TYPE && subtype === WARRANTY_SUBTYPE) {
      result.push(`Months: ${spec.warranty_months || 0}`);
    }
  }

  return result;
};
